import { KeyValue } from 'components/models';

import { BCMapLevelEnum, UpsertBattlecardVariables } from 'app/graphql/generated/graphqlApolloTypes';

import { HierarchyWithTypeAndFirstLevelMemberCount, MapLevelType, HierarchyType } from 'app/models';

export interface BattleCardDesignerDialogFormValues {
  cardName: string;
  currency: KeyValue<string>;
  cardType: KeyValue<string>;
  battleCardOwner: KeyValue<string> | null;
  quotaComponents: { key: string; value: number }[];
  activityFiles: KeyValue<string>[];
  reorderableListItems: {
    hierarchies: string;
    hierarchyId: number;
    hierarchyTop: KeyValue<string>;
    hierarchyType: HierarchyType;
    id: number;
    referToAs: string;
    owner: KeyValue<string> | null;
  }[];
  mapLevel: KeyValue<MapLevelType>;
  quotaBreakdowns: HierarchyWithTypeAndFirstLevelMemberCount[];
  hierarchyBasedTarget: HierarchyWithTypeAndFirstLevelMemberCount;
  description: string;
}

export const getCreateUpdateBCVariables = (
  isCreateMode: boolean,
  deploymentModelId: number,
  parentBCId: number,
  hierarchies: UpsertBattlecardVariables['input']['hierarchies'],
  formSubmitValues: BattleCardDesignerDialogFormValues,
  editingBattleCardId?: number
): UpsertBattlecardVariables['input'] => {
  const quotaDistributionHierarchies = formSubmitValues.quotaBreakdowns
    .map((quotaBreakdown) => +quotaBreakdown.value || null)
    .map((hierarchyId) => ({
      hierarchyRootId: hierarchyId,
      isAllocationTarget: !!(
        formSubmitValues.hierarchyBasedTarget && hierarchyId === +formSubmitValues.hierarchyBasedTarget.value
      )
    }));

  const sharedVariables = {
    deploymentModelId,
    quotaDistributionHierarchies,
    battlecardParentId: parentBCId,
    battlecardName: formSubmitValues.cardName,
    battlecardType: formSubmitValues.cardType.value,
    description: formSubmitValues.description,
    currencyCode: formSubmitValues.currency?.value,
    mapLevel: formSubmitValues.mapLevel.value as BCMapLevelEnum
  };

  if (isCreateMode) {
    return {
      ...sharedVariables,
      teams: [],
      hierarchies,
      memberId: +formSubmitValues.battleCardOwner?.value || null,
      quotaComponent: formSubmitValues.quotaComponents?.map((quotaComponent) => +quotaComponent.value) ?? [],
      fileIds: formSubmitValues.activityFiles?.map((file) => file.value) ?? []
    };
  }
  return {
    ...sharedVariables,
    battlecardId: editingBattleCardId
  };
};
